import { Testkits, TestTypes } from './types';
import * as reactTestUtilsTestkitFactories from '../testkit/index';
import {
  lowerFirst,
  getTestDescription,
  getCorrectTestkitFactories,
  runCorrectTest,
} from './helper-functions';

const COMPONENT_DEFINITIONS = require('./component-definitions.js');
const TESTKIT_DEFINITIONS = require('../../.wuf/testkits/definitions');
const allComponents = require('./all-components');

const DRIVER_ASSERTS = {
  enzyme: ({ name, component, props }) => {
    assertTestkitExists({ name, component, props }, Testkits.enzyme, false);
  },
  vanilla: ({ name, component, props }) => {
    assertTestkitExists({ name, component, props }, Testkits.vanilla, false);
  },
};

const UNIDRIVER_ASSERTS = {
  enzyme: ({ name, component, props }) => {
    assertTestkitExists({ name, component, props }, Testkits.enzyme, true);
  },
  vanilla: ({ name, component, props }) => {
    assertTestkitExists({ name, component, props }, Testkits.vanilla, true);
  },
  initialize: ({ name }) => {
    // Checks that unidriver can initialize even when the element is not found
    describe('Unidriver can initialize', () => {
      it(`Testkit initialize - <${name}/>`, async () => {
        const factory =
          reactTestUtilsTestkitFactories[`${lowerFirst(name)}TestkitFactory`];
        const testkit = factory({
          wrapper: document.createElement('div'),
          dataHook: 'non-existing-data-hook',
        });
        expect(await testkit.exists()).toBe(false);
      });
    });
  },
};

const EXPORT_ASSERTS = {
  enzyme: (name: string) => {
    assertTestkitExports(name, Testkits.enzyme);
  },
  vanilla: (name: string) => {
    assertTestkitExports(name, Testkits.vanilla);
  },
  puppeteer: (name: string) => {
    assertTestkitExports(name, Testkits.puppeteer);
  },
};

const assertTestkitExists = (
  { name, component, props },
  componentTestkit: Testkits,
  isUniDriver: boolean,
) => {
  const testDescription = getTestDescription(
    componentTestkit,
    isUniDriver,
    TestTypes.testkitExists,
  );
  const itDefinition = testDescription.slice(0, testDescription.length - 1);

  describe(testDescription, () => {
    it(`${itDefinition} exists - <${name}/>`, async () =>
      expect(
        await runCorrectTest(
          { name, component, props },
          componentTestkit,
          isUniDriver,
        ),
      ).toBe(true));
  });
};

const assertTestkitExports = (name, componentTestkit: Testkits) => {
  const testDescription = getTestDescription(
    componentTestkit,
    false,
    TestTypes.testkitExports,
  );
  const itDefinition = testDescription.slice(0, testDescription.length - 1);
  const testkit = `${lowerFirst(name)}TestkitFactory`;
  const correctTestkitFactories = getCorrectTestkitFactories(componentTestkit);

  describe(testDescription, () => {
    it(`${itDefinition}ed - <${name}/>`, () =>
      expect(typeof correctTestkitFactories[testkit]).toBe('function'));
  });
};

Object.keys({
  ...allComponents,
}).forEach((name) => {
  const definition = TESTKIT_DEFINITIONS[name] || {};
  const config = {
    props: COMPONENT_DEFINITIONS[name] ? COMPONENT_DEFINITIONS[name].props : {},
    ...definition,
    name,
    component: allComponents[name],
  };

  if (!definition.noTestkit) {
    const sanityAsserts = definition.legacyDriver
      ? DRIVER_ASSERTS
      : UNIDRIVER_ASSERTS;

    Object.keys(sanityAsserts).forEach((driver) => {
      sanityAsserts[driver](config);
    });

    Object.keys(EXPORT_ASSERTS).forEach((driver) => {
      EXPORT_ASSERTS[driver](name);
    });
  }
});
